<template>
  <image-tooltip
    :url="(typeof template.fieldUrl === 'function') ? template.fieldUrl(row, $root) : row[template.fieldUrl] || ''"
    :title="(typeof template.fieldTitle === 'function') ? template.fieldTitle(row, $root) : row[template.fieldTitle] || ''"/>
</template>

<script>
export default {
  name: 'TemplateImage',
  props: {
    row: { type: Object, required: true },
    col: { type: Object, required: true },
    template: { type: Object, required: true }
  }
}
</script>
